export default __webpack_public_path__ + "static/media/md-card-bg-AZ-104.24dac5e2.png";